import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppConfig {
  private config: Object = null;
  private env: Object = null;

  private configDirPath = 'config/';
  private envFile = 'env.json';

  // tslint:disable-next-line: deprecation
  constructor(private http: HttpClient) {}

  /*
   * Use to get the data found in the second file (config file)
   */
  public getConfig(key: any) {
    return this.config[key];
  }

  /*
   * Use to get the data found in the first file (env file)
   */
  public getEnv(key: any) {
    return this.env[key];
  }

  /**
   * This method:
   *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
   *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
   */
  public load() {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(`${this.configDirPath}${this.envFile}?${Math.random()}`)
        .pipe(
          catchError((error: any): any => {
            console.log(
              `Configuration file '${this.configDirPath}${this.envFile}' could not be read`
            );
            resolve(true);
            return throwError(() => error?.error || 'Server error');
          })
        )
        .subscribe((envResponse: any) => {
          this.env = envResponse;
          let request: any = null;
          switch (envResponse.env) {
            case 'prod':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`
                );
              }
              break;
            case 'qa':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`
                );
              }
              break;
            case 'tst':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`
                );
              }
              break;
            case 'dev':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`
                );
              }
              break;
            case 'local':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`
                );
              }
              break;
            case 'default':
              {
                console.error('Environment file is not set or invalid');
                resolve(true);
              }
              break;
          }
          if (request) {
            request
              .pipe(
                catchError((error: any) => {
                  console.error(`Error reading '${envResponse.env}' configuration file.`);
                  resolve(error);
                  return throwError(() => error?.error || 'Server error.');
                })
              )
              .subscribe((responseData: any) => {
                this.config = responseData;
                //console.log(`[CONFIG] Loaded config.${envResponse.env}.json:`, responseData);
                resolve(true);
              });
          } else {
            console.error('Env config file "env.json" is not valid.');
            resolve(true);
          }
        });
    });
  }
}
